module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-bordered table-striped",
    staticStyle: {
      "table-layout": "fixed"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n        Metadados\n        "), _c('span', {
    staticClass: "pull-right clickable show-more",
    on: {
      "click": function($event) {
        _vm.showRequestData = !_vm.showRequestData
      }
    }
  }, [_vm._v(_vm._s(!_vm.showRequestData ? 'Mostrar' : 'Esconder'))])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showRequestData) ? _c('tbody', [(!_vm.isInvited) ? _c('tr', [_c('td', [_vm._v("Nome do Requisitante")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.request.owner.name))])]) : _vm._e(), _vm._v(" "), (!_vm.isInvited) ? _c('tr', [_c('td', [_vm._v("Identificação")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.request.owner.username))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Tipo")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.request.reqType.name))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Status")]), _vm._v(" "), _c('td', [_c('request-status', {
    attrs: {
      "status": _vm.request.status
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Última Atualização")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(_vm.request.updatedAt)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Criação")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(_vm.request.createdAt)))])])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67d75959"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RequestMetadata.vue
// module id = 1456
// module chunks = 1